import React, { useMemo } from 'react';
import * as Diff from 'diff';

var DiffMethod;

(function (DiffMethod) {
  DiffMethod["Chars"] = "diffChars";
  DiffMethod["Words"] = "diffWords";
  DiffMethod["WordsWithSpace"] = "diffWordsWithSpace";
  DiffMethod["Lines"] = "diffLines";
  DiffMethod["TrimmedLines"] = "diffTrimmedLines";
  DiffMethod["Sentences"] = "diffSentences";
  DiffMethod["CSS"] = "diffCss";
})(DiffMethod || (DiffMethod = {}));

var defaultStyle = {
  added: {
    backgroundColor: 'lightgreen'
  },
  removed: {
    backgroundColor: 'salmon'
  },
  "default": {}
};
var StringDiff = function StringDiff(_ref) {
  var oldValue = _ref.oldValue,
      newValue = _ref.newValue,
      _ref$method = _ref.method,
      method = _ref$method === void 0 ? DiffMethod.Chars : _ref$method,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? defaultStyle : _ref$styles,
      className = _ref.className,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'div' : _ref$component;
  var result = useMemo(function () {
    var diff = Diff[method](oldValue, newValue);
    return diff.map(function (part, index) {
      var style = part.added ? styles.added : part.removed ? styles.removed : styles["default"];
      return React.createElement("span", {
        // eslint-disable-next-line react/no-array-index-key
        key: index,
        style: style
      }, part.value);
    });
  }, [oldValue, newValue, method]);
  return React.createElement(Component, {
    className: className
  }, result);
};

export { DiffMethod, StringDiff };
//# sourceMappingURL=react-string-diff.esm.js.map
